export default __webpack_public_path__ + "static/512-512-ce424e18cc1cef75eab2c4899d32791b.png";